import { render, staticRenderFns } from "./FormGroupTree.vue?vue&type=template&id=32435848&scoped=true&"
import script from "./FormGroupTree.vue?vue&type=script&lang=js&"
export * from "./FormGroupTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32435848",
  null
  
)

export default component.exports